import React from 'react';
import PropTypes from 'prop-types';

import styled from '@emotion/styled';
import { css } from '@emotion/core';

const checkedStyles = (props) => css`
  color: ${(props.inverted ? props.theme.color.white : props.theme.color.brand)};

  ::after {
    opacity: 1;

  }

  ::before {
    border-color: ${(props.inverted ? props.theme.color.white : props.theme.color.brand)};
    ${(props.revamp && css`border-width: 5px;`)}
  }
`;

const FILTERED_RADIO_EMO_PROPS = new Set(['active', 'inverted', 'revamp']);

const StyledRadio = styled('label', {
  shouldForwardProp: (prop) => !FILTERED_RADIO_EMO_PROPS.has(prop)
})`
  color: ${(props) => (props.inverted ? props.theme.color.white : props.theme.color.brandLight)};
  cursor: pointer;
  display: block;
  font-family: ${(props) => props.theme.font.sans};
  font-size: ${(props) => props.theme.modularScale.small};
  line-height: 18px;
  padding: 0.5rem 0 0.5rem 2em;
  position: relative;

  ::after,
  ::before {
    position: absolute;
    transition-duration: ${(props) => props.theme.animation.default};
    transition-timing-function: ${(props) => props.theme.animation.easeOutQuad};
  }

  ::after {
    ${({ inverted, revamp, theme }) => (
    !revamp && css`
      background: ${inverted ? theme.color.white : theme.color.brand};`
  )}
    border-radius: 100%;
    content: "";
    display: inline-block;
    height: 0.5em;
    left: 3px;
    opacity: 0;
    top: 11px;
    transition-property: opacity;
    width: 0.5em;
  }

  ::before {
    border-color: ${({ inverted, revamp, theme }) => {
    if (revamp) return theme.color.bluePrimary;
    return (inverted ? theme.color.white : theme.color.brandLight);
  }};
    border-radius: 100%;
    border-style: solid;
    border-width: ${({ revamp }) => (revamp ? '2px' : '1px')};
    content: "";
    display: inline-block;
    height: ${({ revamp }) => (revamp ? '1.6rem' : '1em')};
    left: 0;
    top: 8px;
    transition-property: border-color;
    width: ${({ revamp }) => (revamp ? '1.6rem' : '1em')};
  }

  ${(props) => (props.active ? checkedStyles(props) : '')};

  input[type="radio"] {
    opacity: 0;
    width: 0;
    position: absolute;
  }

  ${({ disabled }) => disabled && css`
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

class Radio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.active
    };

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.updateCheckedStatus(this.props.active);
    }
  }

  updateCheckedStatus(checked) {
    this.setState({ checked });
  }

  handleOnChange(e) {
    this.props.changed();
    this.setState({ checked: e.target.checked });
  }

  render() {
    return (
      <StyledRadio
        htmlFor={this.props.id}
        name={this.props.name}
        inverted={this.props.inverted}
        active={this.state.checked ? 'true' : undefined}
        className={this.props.className}
        revamp={this.props.revamp}
        disabled={this.props.disabled ? 'true' : undefined}
      >
        <input
          id={this.props.id}
          type="radio"
          name={this.props.name}
          checked={this.state.checked}
          onChange={this.handleOnChange}
          disabled={this.props.disabled}
        />
        {this.props.children}
      </StyledRadio>
    );
  }
}

Radio.defaultProps = {
  className: '',
  inverted: false,
  active: false,
  revamp: false,
  changed: () => { },
  disabled: false
};

Radio.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  inverted: PropTypes.bool,
  revamp: PropTypes.bool,
  changed: PropTypes.func,
  disabled: PropTypes.bool
};

export default Radio;
